export const GET_MEDIA_OF_MONTH = 'app/Media/GET_MEDIA_OF_MONTH'
export const CLEAR_MEDIA = 'app/Media/CLEAR_MEDIA'
export const GET_MEDIA_OF_MONTH_DONE = 'app/Media/GET_MEDIA_OF_MONTH_DONE'
export const GET_MEDIA_OF_MONTH_ERROR = 'app/Media/GET_MEDIA_OF_MONTH_ERROR'

export const GET_MEDIA_FOR_ISSUE_OF_MONTH =
  'app/Media/GET_MEDIA_FOR_ISSUE_OF_MONTH'
export const CLEAR_ISSUE_MEDIA = 'app/Media/CLEAR_ISSUE_MEDIA'
export const GET_MEDIA_FOR_ISSUE_OF_MONTH_DONE =
  'app/Media/GET_MEDIA_FOR_ISSUE_OF_MONTH_DONE'
export const GET_MEDIA_FOR_ISSUE_OF_MONTH_ERROR =
  'app/Media/GET_MEDIA_FOR_ISSUE_OF_MONTH_ERROR'

export const GET_PROJECT_MEDIA = 'app/Media/GET_PROJECT_MEDIA'
export const GET_PROJECT_MEDIA_DONE = 'app/Media/GET_PROJECT_MEDIA_DONE'
export const GET_PROJECT_MEDIA_ERROR = 'app/Media/GET_PROJECT_MEDIA_ERROR'

export const SET_PROJECT_MEDIA_ACTIVE_STATE =
  'app/Media/SET_PROJECT_MEDIA_ACTIVE_STATE'

export const DOWNLOAD_FILES_AS_ZIP = 'app/Media/DOWNLOAD_FILES_AS_ZIP'
export const DOWNLOAD_FILES_AS_ZIP_DONE = 'app/Media/DOWNLOAD_FILES_AS_ZIP_DONE'
export const DOWNLOAD_FILES_AS_ZIP_GET_STATUS =
  'app/Media/DOWNLOAD_FILES_AS_ZIP_GET_STATUS'
export const DOWNLOAD_FILES_AS_ZIP_SET_STORAGE_ID =
  'app/Media/DOWNLOAD_FILES_AS_ZIP_SET_STORAGE_ID'
export const DOWNLOAD_FILES_AS_ZIP_SET_PERCENTAGE =
  'app/Media/DOWNLOAD_FILES_AS_ZIP_SET_PERCENTAGE'
export const DOWNLOAD_FILES_AS_ZIP_FAILED =
  'app/Media/DOWNLOAD_FILES_AS_ZIP_FAILED'
export const DOWNLOAD_FILES_AS_ZIP_ERROR =
  'app/Media/DOWNLOAD_FILES_AS_ZIP_ERROR'
